import { render, staticRenderFns } from "./CredenciamentoFornecedorAcoes.vue?vue&type=template&id=5e383aca&scoped=true"
import script from "./CredenciamentoFornecedorAcoes.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorAcoes.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorAcoes.vue?vue&type=style&index=0&id=5e383aca&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e383aca",
  null
  
)

export default component.exports